<p-toast role="status" aria-live="polite" aria-atomic="true" />

<div class="contract-sections-form-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb 
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()" 
      [home]="{icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard'}">
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header" aria-labelledby="page-heading">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-file-edit header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-heading">{{ editId ? 'Modifica Blocco di Testo' : 'Nuovo Blocco di Testo' }}</h1>
          <p class="subtitle">{{ editId ? 'Modifica il contenuto del blocco di testo' : 'Crea un nuovo blocco di testo riutilizzabile' }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Editor Main Area -->
  <main class="editor-main" aria-label="Editor sezioni">
    <div class="editor-header field">
      <label for="section-title" class="block text-sm font-medium mb-1">
        Titolo blocco di testo <span class="text-red-500" aria-hidden="true">*</span>
        <span class="sr-only">(obbligatorio)</span>
      </label>
      <input
        id="section-title"
        pInputText
        type="text"
        placeholder="Titolo blocco di testo"
        [(ngModel)]="name"
        (blur)="markTitleTouched()"
        class="w-full"
        [attr.aria-required]="true"
        [attr.aria-invalid]="isTitleInvalid() ? 'true' : 'false'"
        [attr.aria-describedby]="
          isTitleInvalid() ? 'section-title-help section-title-error' : 'section-title-help'
        "
      />
      <small id="section-title-help" class="sr-only">
        Inserisci un titolo descrittivo per il blocco di testo.
      </small>
      <small
        id="section-title-error"
        class="p-error block mt-1"
        role="alert"
        *ngIf="isTitleInvalid()"
      >
        Il titolo del blocco di testo è obbligatorio.
      </small>
    </div>
    <div class="editor-fields flex gap-3">
      <div class="flex-1 field">
        <label for="root-table" class="block text-sm font-medium mb-1">
          Entità Principale Blocco di Testo <span class="text-red-500" aria-hidden="true">*</span>
          <span class="sr-only">(obbligatorio)</span>
        </label>
        <p-select
          id="root-table"
          [ngModel]="rootTable"
          (ngModelChange)="onRootTableChange($event)"
          [options]="rootTableOptions"
          optionLabel="valueDescription"
          optionValue="valueKey"
          placeholder="Seleziona entità principale"
          class="w-full"
          (blur)="markRootTableTouched()"
          [attr.aria-required]="true"
          [ariaLabel]="'Entità principale blocco di testo'"
          [attr.aria-invalid]="isRootTableInvalid() ? 'true' : 'false'"
          [attr.aria-describedby]="
            isRootTableInvalid() ? 'root-table-help root-table-error' : 'root-table-help'
          "
        ></p-select>
        <small id="root-table-help" class="sr-only">
          Seleziona l'entità principale su cui è basato il blocco di testo.
        </small>
        <small
          id="root-table-error"
          class="p-error block mt-1"
          role="alert"
          *ngIf="isRootTableInvalid()"
        >
          Seleziona l'entità principale del blocco di testo.
        </small>
      </div>

      @if (showRepeatableField) {
        <div class="flex-1">
          <fieldset>
            <legend id="repeatable-legend" class="block text-sm font-medium mb-2">
              Ripeti blocco di testo per ogni entità
            </legend>
            <div class="flex gap-4" role="radiogroup" [attr.aria-labelledby]="'repeatable-legend'">
              @for (option of yesNoOptions; track option.value) {
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="isRepeatable"
                    [inputId]="'isRepeatable-' + option.value"
                    [value]="option.value"
                    [(ngModel)]="isRepeatable"
                  ></p-radiobutton>
                  <label [for]="'isRepeatable-' + option.value" class="ml-2">{{
                    option.label
                  }}</label>
                </div>
              }
            </div>
          </fieldset>
        </div>
      }
    </div>
    <div class="editor-content">
      <!-- Pannello unificato Variabili e Allegati -->
      <div
        class="variables-panel"
        role="complementary"
        aria-label="Variabili e Allegati disponibili"
      >
        <!-- Sezione Variabili -->
        <h4
          class="text-sm font-semibold mb-2 sidebar-heading flex align-items-center justify-content-between cursor-pointer select-none hover:text-900"
          (click)="toggleVariablesSection()"
          (keydown.enter)="toggleVariablesSection()"
          (keydown.space)="$event.preventDefault(); toggleVariablesSection()"
          tabindex="0"
          role="button"
          [attr.aria-expanded]="!variablesSectionCollapsed"
          aria-controls="variables-section-content"
          [attr.title]="(variablesSectionCollapsed ? 'Espandi' : 'Comprimi') + ' Variabili'"
        >
          Variabili
          <i
            class="pi text-xs ml-1"
            [ngClass]="variablesSectionCollapsed ? 'pi-chevron-right' : 'pi-chevron-down'"
            aria-hidden="true"
          ></i>
        </h4>

        <div id="variables-section-content" [hidden]="variablesSectionCollapsed">

        <!-- Campo di ricerca variabili -->
        <label for="search-variables" class="sr-only">Cerca variabili</label>
        <p-iconfield class="mb-2">
          <p-inputicon class="pi pi-search"></p-inputicon>
          <input
            id="search-variables"
            type="text"
            pInputText
            [(ngModel)]="variableSearchText"
            placeholder="Cerca variabili..."
            class="w-full text-xs"
            aria-label="Cerca variabili disponibili"
          />
        </p-iconfield>

        <!-- Variabili raggruppate per sourceForm -->
        @for (groupKey of groupKeys; track groupKey) {
          <div class="mb-3" role="group" [attr.aria-labelledby]="'var-group-' + groupKey">
            <h5
              [id]="'var-group-' + groupKey"
              class="text-xs font-semibold text-600 mb-1 px-1 flex align-items-center justify-content-between cursor-pointer select-none hover:text-900"
              (click)="toggleGroup(groupKey)"
              (keydown.enter)="toggleGroup(groupKey)"
              (keydown.space)="$event.preventDefault(); toggleGroup(groupKey)"
              tabindex="0"
              role="button"
              [attr.aria-expanded]="!collapsedGroups.has(groupKey)"
              [attr.aria-controls]="'var-group-items-' + groupKey"
              [attr.title]="(collapsedGroups.has(groupKey) ? 'Espandi' : 'Comprimi') + ' ' + groupKey"
            >
              {{ groupKey }}
              <i
                class="pi text-xs ml-1"
                [ngClass]="collapsedGroups.has(groupKey) ? 'pi-chevron-right' : 'pi-chevron-down'"
                aria-hidden="true"
              ></i>
            </h5>

            <div [id]="'var-group-items-' + groupKey" [hidden]="collapsedGroups.has(groupKey)">
            @for (v of groupedVariables[groupKey]; track v.id) {
              <div
                class="variable surface-card p-2 mb-2 border-1 border-300 border-round cursor-pointer text-xs hover:surface-100 flex align-items-center gap-1"
                (click)="insertVariable(v.variableKey, v.id)"
                role="button"
                [attr.aria-label]="'Inserisci variabile ' + v.displayName + ' nell editor'"
                [attr.title]="'Clicca per inserire: ' + v.displayName"
                tabindex="0"
                (keydown.enter)="insertVariable(v.variableKey, v.id)"
                (keydown.space)="$event.preventDefault(); insertVariable(v.variableKey, v.id)"
              >
                <i class="pi pi-plus text-xs text-400" aria-hidden="true"></i>
                <span>{{ v.displayName }}</span>
              </div>
            }
            </div>
          </div>
        }

        <!-- Messaggio quando non ci sono risultati -->
        @if (groupKeys.length === 0 && variableSearchText.trim()) {
          <div class="text-xs text-500 text-center p-2" role="status" aria-live="polite">
            Nessuna variabile trovata
          </div>
        }

        </div><!-- /variables-section-content -->

        <!-- Divisore -->
        <p-divider class="my-3"></p-divider>

        <!-- Sezione Allegati -->
        <h4
          class="text-sm font-semibold mb-2 sidebar-heading flex align-items-center justify-content-between cursor-pointer select-none hover:text-900"
          (click)="toggleAttachmentsSection()"
          (keydown.enter)="toggleAttachmentsSection()"
          (keydown.space)="$event.preventDefault(); toggleAttachmentsSection()"
          tabindex="0"
          role="button"
          [attr.aria-expanded]="!attachmentsSectionCollapsed"
          aria-controls="attachments-section-content"
          [attr.title]="(attachmentsSectionCollapsed ? 'Espandi' : 'Comprimi') + ' Allegati'"
        >
          Allegati
          <i
            class="pi text-xs ml-1"
            [ngClass]="attachmentsSectionCollapsed ? 'pi-chevron-right' : 'pi-chevron-down'"
            aria-hidden="true"
          ></i>
        </h4>

        <div id="attachments-section-content" [hidden]="attachmentsSectionCollapsed">

        <!-- Campo di ricerca allegati -->
        <label for="search-attachments" class="sr-only">Cerca allegati</label>
        <p-iconfield class="mb-2">
          <p-inputicon class="pi pi-search"></p-inputicon>
          <input
            id="search-attachments"
            type="text"
            pInputText
            [(ngModel)]="attachmentSearchText"
            placeholder="Cerca allegati..."
            class="w-full text-xs"
            aria-label="Cerca allegati disponibili"
          />
        </p-iconfield>

        <!-- Allegati -->
        @for (attachment of filteredAttachments; track attachment.id) {
          <div
            class="attachment surface-card p-2 mb-2 border-1 border-300 border-round cursor-pointer text-xs hover:surface-100 flex align-items-center gap-1"
            (click)="insertAttachment(attachment.id!)"
            role="button"
            [attr.aria-label]="'Inserisci allegato ' + attachment.title + ' nell editor'"
            [attr.title]="'Clicca per inserire allegato: ' + attachment.title"
            tabindex="0"
            (keydown.enter)="insertAttachment(attachment.id!)"
            (keydown.space)="$event.preventDefault(); insertAttachment(attachment.id!)"
          >
            <i class="pi pi-plus text-xs text-400" aria-hidden="true"></i>
            <span>{{ attachment.title }}</span>
          </div>
        }

        <!-- Messaggio quando non ci sono risultati -->
        @if (filteredAttachments.length === 0 && attachmentSearchText.trim()) {
          <div class="text-xs text-500 text-center p-2" role="status" aria-live="polite">
            Nessun allegato trovato
          </div>
        }

        <!-- Messaggio quando non ci sono allegati -->
        @if (filteredAttachments.length === 0 && !attachmentSearchText.trim()) {
          <div class="text-xs text-500 text-center p-2" role="status" aria-live="polite">
            Nessun allegato disponibile
          </div>
        }

        </div><!-- /attachments-section-content -->
      </div>

      <div
        class="jodit-container"
        role="region"
        aria-labelledby="jodit-editor-label"
      >
        <label id="jodit-editor-label" for="jodit-editor" class="sr-only"
          >Editor contenuto blocco di testo</label
        >
        <div
          #joditEditor
          id="jodit-editor"
          aria-label="Editor contenuto blocco di testo"
          [attr.aria-invalid]="!contentText ? 'true' : 'false'"
          aria-describedby="jodit-help"
        ></div>
        <small id="jodit-help" class="sr-only">
          Inserisci il contenuto del blocco di testo nell'editor.
        </small>
      </div>
    </div>

    <div
      class="editor-actions flex justify-content-between gap-2"
      role="group"
      aria-label="Azioni editor"
    >
      <!-- Pulsanti a sinistra -->
      <div class="flex gap-2">
        <p-button
          label="Anteprima"
          icon="pi pi-eye"
          [outlined]="true"
          (onClick)="previewCurrent()"
          ariaLabel="Visualizza anteprima contenuto"
          [attr.title]="'Visualizza anteprima contenuto'"
        ></p-button>

        <p-button
          label="Scarica Word"
          icon="pi pi-file-word"
          [outlined]="true"
          (onClick)="generateWordFrontend()"
          [disabled]="!name || isGenerating"
          ariaLabel="Scarica documento Word"
          [attr.title]="'Scarica documento Word'"
        ></p-button>

        <p-button
          label="Scarica PDF"
          icon="pi pi-file-pdf"
          [outlined]="true"
          severity="danger"
          (onClick)="generatePdfFrontend()"
          [disabled]="!name || isGenerating"
          ariaLabel="Scarica documento PDF"
          [attr.title]="'Scarica documento PDF'"
        ></p-button>

        @if (isGenerating) {
          <span class="ml-2 text-sm" role="status" aria-live="polite" aria-atomic="true">
            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            <span>Generazione in corso...</span>
          </span>
        }
      </div>

      <!-- Pulsanti a destra -->
      <div class="flex gap-2">
        <p-button
          label="Annulla"
          severity="secondary"
          [variant]="'outlined'"
          (onClick)="cancelEdit()"
          *ngIf="editId"
          ariaLabel="Annulla modifiche e ripristina editor"
          [attr.title]="'Annulla modifiche e ripristina editor'"
        >
        </p-button>

        <p-button
            label="Salva"
            icon="pi pi-check"
            [loading]="isSaving"
            (onClick)="saveSection()"
            ariaLabel="Salva blocco di testo"
            [attr.title]="'Salva blocco di testo'"
          ></p-button>
      </div>
    </div>
  </main>
</div>

<!-- Preview Dialog -->
<p-dialog
  [(visible)]="previewVisible"
  [modal]="true"
  [style]="{ width: '70vw' }"
  [draggable]="false"
  [resizable]="false"
  [header]="previewData?.title || 'Anteprima'"
  aria-modal="true"
  [ariaLabel]="previewData?.title || 'Anteprima blocco di testo'"
  [contentStyle]="{ overflow: 'auto' }"
>
  <div
    class="preview-content"
    [innerHTML]="previewData?.content"
    role="document"
    aria-label="Contenuto anteprima blocco di testo"
  ></div>

  <ng-template pTemplate="footer">
    <p-button
      label="Chiudi"
      (onClick)="previewVisible = false"
      [variant]="'outlined'"
      ariaLabel="Chiudi finestra anteprima"
      [attr.title]="'Chiudi finestra anteprima'"
    ></p-button>
  </ng-template>
</p-dialog>
